import moment from "../../node_modules/moment/moment";
//import { getLocaleOrDefault } from "./localStorage";
export const DATE_STYLES = {
  FULL: "full",
  LONG: "long",
  MEDIUM: "medium",
  SHORT: "short"
};

export const TIME_STYLES = {
  FULL: "full",
  LONG: "long",
  MEDIUM: "medium",
  SHORT: "short"
};

export const CURRENCY_STYLES = {
  LONG: "long",
  SHORT: "short"
};

export const NUMBER_STYLES = {
  LONG: "long",
  SHORT: "short"
};

let default_timezone, currency;
let userLocale = "en-SG";
let i18n,
  date_formats,
  time_formats,
  currency_formats = {};

export function setGlobalSettingsForFormatter(globalSettings) {
  i18n = globalSettings.country_config.i18n;
  default_timezone = globalSettings?.country_config?.default_timezone;
  currency = globalSettings?.country_config?.currency;

  date_formats = i18n?.date_formats;
  time_formats = i18n?.time_formats;
  currency_formats = i18n?.currency_formats;
}

export function setUserLocaleForFormatter(locale) {
  userLocale = locale;
}

export function formatDate(dateObj, { style, localeString }) {
  const pattern = date_formats
    ? date_formats[style].split("d").join("D")
    : "DD/MM/yyyy (ddd)";

  if (!pattern) {
    return new Intl.DateTimeFormat(localeString ?? userLocale, {
      dateStyle: style,
      timeZone: default_timezone
    }).format(dateObj);
  }
  // return Lib specific code, moment or date-fns
  return moment(dateObj).format(pattern); //
}

export function formatTime(dateObj, { style, localeString }) {
  const pattern = time_formats ? time_formats[style] : undefined;
  if (!pattern) {
    return new Intl.DateTimeFormat(localeString ?? userLocale, {
      timeStyle: style,
      timeZone: default_timezone
    }).format(dateObj);
  }
  // return Lib specific code, moment or date-fns
  return moment(dateObj).format(pattern); //
}

export function formatCurrency(
  num,
  { style, localeString, numberOptionsOveride = {} }
) {
  const numberOpts = currency_formats[style];
  const { symbol } = currency || {};
  const numPart = new Intl.NumberFormat(localeString ?? userLocale, {
    style: "decimal",
    ...numberOpts,
    ...numberOptionsOveride
  }).format(num);
  return `${symbol}. ${numPart}`;
}

export function formatNumber(num, { style, localeString }) {
  const numberOpts = currency_formats[style];
  return new Intl.NumberFormat(localeString ?? userLocale, {
    style: "currency",
    ...numberOpts
  }).format(num);
}
